exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width: 480px) {\n[data-v-deae528e] .fc-toolbar {\n    flex-wrap: wrap;\n}\n}\n", ""]);

// exports
